// mds-dojo — dojo/_base/array. Slim of the array helpers used by the oracle.
// dojo's array fns accept a NodeList/array-like and a string|function callback.

function toFn(cb: any, thisObj?: any): (item: any, i: number, arr: any) => any {
  if (typeof cb === 'string') {
    // dojo historically supported string-expression callbacks (eval'd per item). NOT used
    // anywhere in this codebase (verified) — and we deliberately keep the bundle free of
    // eval / new Function (CSP). Pass a real function instead.
    throw new Error('mds-dojo/array: string callbacks are not supported (no eval). Pass a function.');
  }
  return thisObj ? cb.bind(thisObj) : cb;
}

export function forEach(arr: any, cb: any, thisObj?: any): void {
  if (!arr) { return; }
  const fn = toFn(cb, thisObj);
  for (let i = 0; i < arr.length; i++) { fn(arr[i], i, arr); }
}

export function map(arr: any, cb: any, thisObj?: any): any[] {
  const fn = toFn(cb, thisObj);
  const out: any[] = [];
  for (let i = 0; i < (arr ? arr.length : 0); i++) { out.push(fn(arr[i], i, arr)); }
  return out;
}

export function filter(arr: any, cb: any, thisObj?: any): any[] {
  const fn = toFn(cb, thisObj);
  const out: any[] = [];
  for (let i = 0; i < (arr ? arr.length : 0); i++) {
    if (fn(arr[i], i, arr)) { out.push(arr[i]); }
  }
  return out;
}

export function indexOf(arr: any, value: any): number {
  for (let i = 0; i < (arr ? arr.length : 0); i++) { if (arr[i] === value) { return i; } }
  return -1;
}

export function some(arr: any, cb: any, thisObj?: any): boolean {
  const fn = toFn(cb, thisObj);
  for (let i = 0; i < (arr ? arr.length : 0); i++) { if (fn(arr[i], i, arr)) { return true; } }
  return false;
}

export function every(arr: any, cb: any, thisObj?: any): boolean {
  const fn = toFn(cb, thisObj);
  for (let i = 0; i < (arr ? arr.length : 0); i++) { if (!fn(arr[i], i, arr)) { return false; } }
  return true;
}

const array = { forEach, map, filter, indexOf, some, every };
export default array;
